import * as React from 'react';
import { RangedNumberFilterEdit } from '.';
import { RangedValueFilterEditProps } from '../providers/RangedValue';

interface RangedDecimalFieldEditState {
	fromValue: string;
	toValue: string;
}

/**
 * Configures a range of integer values in a filter
 */
class RangedIntegerFilterEdit extends React.PureComponent<RangedValueFilterEditProps, RangedDecimalFieldEditState> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <RangedNumberFilterEdit {...this.props} step="1" />;
	}
}

export default RangedIntegerFilterEdit;
